import { createReducer, on } from '@ngrx/store';

import { ErrorMessage, MocketBankAccount, MocketBankList } from '@shared/models';
import { MocketBankAccountActions } from '@shared/store/mocketbnk-store/mocketbank-account.actions';

export const mocketBankAccountFeatureKey = 'mocketBankAccountPage';

export interface MocketBankAccountState {
  mocketBankAccounts: MocketBankList['items'] | null;
  selectedAccount: MocketBankAccount | undefined;
  isLoading: boolean;
  totalElements: number;
  error: ErrorMessage;
}

export const initialMocketBankAccountState: MocketBankAccountState = {
  mocketBankAccounts: null,
  isLoading: false,
  totalElements: 0,
  selectedAccount: undefined,
  error: null,
};

export const reducer = createReducer(
  initialMocketBankAccountState,
  on(MocketBankAccountActions.loadMocketBankAccounts, (state): MocketBankAccountState => {
    return {
      ...state,
      isLoading: true,
      totalElements: 0,
      mocketBankAccounts: null,
      selectedAccount: undefined,
      error: null,
    };
  }),
  on(MocketBankAccountActions.loadMocketBankAccountSuccess, (state, action): MocketBankAccountState => {
    return {
      ...state,
      mocketBankAccounts: action.mocketBankAccounts,
      totalElements: action.totalElements,
      selectedAccount: undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(MocketBankAccountActions.loadMocketBankAccountError, (state, action): MocketBankAccountState => {
    return {
      ...state,
      isLoading: false,
      error: action.error,
    };
  }),
  on(MocketBankAccountActions.setMocketBankAccount, (state, action): MocketBankAccountState => {
    return {
      ...state,
      selectedAccount: action.selectedAccount,
      isLoading: false,
      error: null,
    };
  }),
);

export const getMocketBankAccounts = (state: MocketBankAccountState) => state?.mocketBankAccounts;
export const getSelectedMocketBankAccount = (state: MocketBankAccountState) => state?.selectedAccount;
export const getTotalElements = (state: MocketBankAccountState) => state?.totalElements;
export const getLoading = (state: MocketBankAccountState) => state?.isLoading;
export const getError = (state: MocketBankAccountState) => state?.error;
